import { Component } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-alumni',
  standalone: true,
  imports: [SvgIconComponent],
  templateUrl: './alumni.component.html',
  styleUrl: './alumni.component.scss'
})
export class AlumniComponent {
  defaultAvatar = environment.defaultAvatar;
  profileImageUrl = environment.defaultAvatar;

  AlumniList: any = [];
}
